"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var PWAContext = _react["default"].createContext();

var _default = PWAContext;
exports["default"] = _default;
//# sourceMappingURL=PWAContext.js.map